// Imports: local files.
import {
  GET_ALL_ARTICLES_START,
  GET_ALL_ARTICLES_SUCCESS,
  GET_ALL_ARTICLES_FAILED,
  GET_ALL_ARTICLES_RESET,
  GET_ONE_ARTICLE_START,
  GET_ONE_ARTICLE_SUCCESS,
  GET_ONE_ARTICLE_FAILED,
  GET_ONE_ARTICLE_RESET,
  CREATE_ARTICLE_START,
  CREATE_ARTICLE_SUCCESS,
  CREATE_ARTICLE_FAILED,
  CREATE_ARTICLE_RESET,
  UPDATE_ONE_ARTICLE_START,
  UPDATE_ONE_ARTICLE_SUCCESS,
  UPDATE_ONE_ARTICLE_FAILED,
  UPDATE_ONE_ARTICLE_RESET,
  UPLOAD_PHOTO_ARTICLE_START,
  UPLOAD_PHOTO_ARTICLE_SUCCESS,
  UPLOAD_PHOTO_ARTICLE_FAILED,
  UPLOAD_PHOTO_ARTICLE_RESET,
  DELETE_ONE_ARTICLE_START,
  DELETE_ONE_ARTICLE_SUCCESS,
  DELETE_ONE_ARTICLE_FAILED,
  DELETE_ONE_ARTICLE_RESET,
} from '../actions/actions';

const initialLoadingState = {
  loading: false,
  success: false,
  data: null,
  error: false,
  errorMessage: null,
};
const initialState = {
  getAll: initialLoadingState,
  getOne: initialLoadingState,
  create: initialLoadingState,
  updateOne: initialLoadingState,
  uploadPhoto: initialLoadingState,
  deleteOne: initialLoadingState,
};

const articlesReducer = (state = initialState, action) => {
  switch (action.type) {
    /**
     * =======================================================================
     * Get All Articles
     * =======================================================================
     */
    case GET_ALL_ARTICLES_START:
      return { ...state, getAll: { ...action.payload } };
    case GET_ALL_ARTICLES_SUCCESS:
      return { ...state, getAll: { ...action.payload } };
    case GET_ALL_ARTICLES_FAILED:
      return { ...state, getAll: { ...action.payload } };
    case GET_ALL_ARTICLES_RESET:
      return { ...state, getAll: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Get One Article
     * =======================================================================
     */
    case GET_ONE_ARTICLE_START:
      return { ...state, getOne: { ...action.payload } };
    case GET_ONE_ARTICLE_SUCCESS:
      return { ...state, getOne: { ...action.payload } };
    case GET_ONE_ARTICLE_FAILED:
      return { ...state, getOne: { ...action.payload } };
    case GET_ONE_ARTICLE_RESET:
      return { ...state, getOne: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Create New Article
     * =======================================================================
     */
    case CREATE_ARTICLE_START:
      return { ...state, create: { ...action.payload } };
    case CREATE_ARTICLE_SUCCESS:
      return { ...state, create: { ...action.payload } };
    case CREATE_ARTICLE_FAILED:
      return { ...state, create: { ...action.payload } };
    case CREATE_ARTICLE_RESET:
      return { ...state, create: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Update One Article
     * =======================================================================
     */
    case UPDATE_ONE_ARTICLE_START:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_ONE_ARTICLE_SUCCESS:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_ONE_ARTICLE_FAILED:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_ONE_ARTICLE_RESET:
      return { ...state, updateOne: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Upload Photo Article
     * =======================================================================
     */
    case UPLOAD_PHOTO_ARTICLE_START:
      return { ...state, uploadPhoto: { ...action.payload } };
    case UPLOAD_PHOTO_ARTICLE_SUCCESS:
      return { ...state, uploadPhoto: { ...action.payload } };
    case UPLOAD_PHOTO_ARTICLE_FAILED:
      return { ...state, uploadPhoto: { ...action.payload } };
    case UPLOAD_PHOTO_ARTICLE_RESET:
      return { ...state, uploadPhoto: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Delete One Article
     * =======================================================================
     */
    case DELETE_ONE_ARTICLE_START:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_ONE_ARTICLE_SUCCESS:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_ONE_ARTICLE_FAILED:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_ONE_ARTICLE_RESET:
      return { ...state, deleteOne: { ...initialLoadingState } };
    default:
      return state;
  }
};

export default articlesReducer;
